export const checkString = (text) => {
  const pattern = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
  if (text.match(pattern)) {
    return true;
  } else {
    return false;
  }
};

export const checkUsername = (text) => {
  const pattern = /^[a-z]+[a-z0-9]+$/;
  if (text.match(pattern)) {
    return true;
  } else {
    return false;
  }
};

export const checkAnchor = (text) => {
  const pattern = /^[a-zA-Z0-9]+[a-zA-Z0-9-_.@]+[a-zA-Z0-9-_]+$/;
  if (text.match(pattern)) {
    return true;
  } else {
    return false;
  }
};

export const checkUrl = (text) => {
  const pattern = /^(https:\/\/?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*))?$/;
  if (text.match(pattern)) {
    return true;
  } else {
    return false;
  }
};
